import { jsx as n } from "@emotion/react/jsx-runtime";
import { ErrorsContainer as i, StyledText as l } from "./ErrorList.styled.js";
const d = ({
  errors: r,
  errorTranslations: o
}) => r.length === 0 ? null : /* @__PURE__ */ n(i, { children: r.map(({
  code: t,
  message: e
}) => /* @__PURE__ */ n(l, { variant: "bodySRegular", as: "li", color: "danger", children: o?.[t] ?? e }, t)) });
export {
  d as ErrorList
};
